import { render, staticRenderFns } from "./App.vue?vue&type=template&id=2bed9e1e&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
import style0 from "./App.vue?vue&type=style&index=0&id=2bed9e1e&prod&lang=scss&scoped=true"
import style1 from "./App.vue?vue&type=style&index=1&id=2bed9e1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bed9e1e",
  null
  
)

export default component.exports